import axios from "axios";
import { CONFIG_MAP_UPDATE } from "./Events";

export function updateConfigMap(config) {
  return function (dispatch) {
    dispatch({ type: CONFIG_MAP_UPDATE, payload: config });
  };
}


export function getMapConfig(mapKey, successCallback, errorCallback) {
  return function (dispatch) {
    const request = axios.get(`/PublicConfig/GetMap?key=${mapKey}`);
    request
      .then(response => {
        if (successCallback) {
          successCallback(response);
        }
      })
      .catch(() => {
        if (errorCallback)
          errorCallback();
      });

  };
}